<script>
    // https://www.sitepoint.com/svelte-fetch-data/
import { onMount } from "svelte";
import axios from "axios";
import Angebot from './Angebot.svelte';
const endpoint = "https://spiele.ulrichlang.de/angebote.php";
  let angebote = [];

  onMount(async function () {
  try {
    const response = await axios.get(endpoint);
    angebote = response.data;

  if (!angebote){
    console.log("Es liegen keine Angebote vor");
  } else{
    console.log(response.data);
    
    
    // console.log("Test");
  }
  } catch (error) {
    console.error(error);
  }
});

</script>
<style>


</style>
<main>

<Angebot {angebote} />
 
</main>
